import React, { Component } from 'react';
import { connect } from "react-redux";
import { decrypt } from 'utils/encrypt_decrypt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as auth from "store/auth/user/action";

class EarnipayAdminLogin extends Component {
    state = { 
        pageAccess: "",
    }


    componentDidMount() {
        let pageAccess = false;
        if ("payload" in this.props.match.params){
            const {payload} = this.props.match.params;
            if (payload !== "") {
                
                const userDataString = decrypt(payload);
                if (userDataString !== false){
                    const userDataObj = JSON.parse(userDataString);
                    if (userDataObj.data && userDataObj.data.token && userDataObj.data.token !== ""){
                        pageAccess = true;
                        this.props.earnipayAdminLogin(userDataObj.data);
                    }
                }

            }
        }
        this.setState({pageAccess});
    }


    render() { 
        const {user} = this.props;

        return (
            <div className="">
                <div className="">

                    {(this.state.pageAccess === false) &&
                        <div className="w-96 mx-auto md:py-24 md:mt-6">
                            <div className="table-info">
                                <FontAwesomeIcon icon="exclamation-circle" className="text-red-700" style={{"fontSize":"6rem"}} />
                                <div className="mt-2 font-bold text-2xl">
                                    Access Denied
                                </div>
                                <div className="mt-3">
                                    Please recheck your link & try again
                                </div>
                                <div className="mt-6 space-y-2 max-w-xs mx-auto">
                                    <button type="button" onClick={() => window.location.href = "/"} className="btn btn-block btn-lg btn-ep-primary mx-auto">
                                        Home
                                    </button>
                                </div>
                            </div>
                        </div>
                    }

                    {(this.state.pageAccess === true) &&
                        <div className="w-96 mx-auto md:py-24 md:mt-6">
                            <div className="table-info">
                                <FontAwesomeIcon icon="check-circle" className="text-green-600" style={{"fontSize":"6rem"}} />
                                <div className="mt-2 font-bold text-2xl font-recoleta">
                                    Welcome Admin
                                </div>
                                <div className="mt-3">
                                    you are now identified as&nbsp;
                                    <br className="hidden md:block" />
                                    <span className="font-bold text-ep-primary">
                                        {user.name}&nbsp;
                                        <span className="capitalize">
                                            ({user.employer.userType})
                                        </span>
                                    </span>
                                </div>
                                <div className="mt-6 space-y-2 max-w-xs mx-auto">
                                    <button type="button" onClick={() => window.location.href = "/dashboard"} className="btn btn-block btn-lg btn-ep-primary mx-auto">
                                        Goto Dashboard
                                    </button>
                                    <button type="button" onClick={this.props.logout} className="btn btn-block btn-lg btn-transparent-black mx-auto">
                                        Sign Out
                                    </button>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    loggedIn: state.auth.userPersist.loggedIn,
    user: state.auth.userPersist.data,
});

const mapDispatchToProps = (dispatch) => ({
    earnipayAdminLogin: (params) => dispatch(auth.earnipayAdminLogin(params)),
    logout: () => dispatch(auth.logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EarnipayAdminLogin);